import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UploadMacAddressService } from "../../../shared/services/upload-mac-address/upload-mac-address.service";
import { first } from "rxjs/operators";
@Component({
  selector: 'app-upload-mac-address',
  templateUrl: './upload-mac-address.component.html',
  styleUrls: ['./upload-mac-address.component.scss']
})
export class UploadMacAddressComponent implements OnInit {

  fileType: any =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  dataCount: any;
  uploadType: any = "import";
  error: any;
  uploadmacaddressdata = false;
  sender = "upload-mac-address";

  constructor(
    private router: Router,
    private uploadMacAddressService: UploadMacAddressService
  ) { }
  ngOnInit() {
  }
  ondocImport(e) {
    this.uploadmacaddressdata = e;
  }

  ondocError(e) {
    this.error = e;
  }

  onConfirm() {
    this.uploadMacAddressService
      .saveUploadedMacAddress(this.uploadmacaddressdata)
      .pipe(first())
      .subscribe(res => {
        this.router.navigate(["manager/mac-address-list"]);
      });
  }
}
